// extracted by mini-css-extract-plugin
export default {"sliderContainer":"styles_sliderContainer__Bszl4","slider":"styles_slider__Ux8aY","sliderLabels":"styles_sliderLabels__ConRK"};